import STPFileIcon from 'components/Icons/STPFileIcon'
import PropTypes from 'prop-types'
import React from 'react'
import { withTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import ReactTooltip from 'react-tooltip'
import { openFreshPartFile } from 'store/actions'

export const StpDownloader = ({ partId, t }) => {
	const dispatch = useDispatch()
	const url = useSelector(state =>
		(/** @type {StoreState} */(state)).CloudStorage.partsFiles?.parts?.find(p => parseInt(p.id) === partId)?.fileLinks?.stepModel
	)
	const tooltipId = partId + '_stp'

	return (
		<div>
			{url ?
				<div className="cursor" onClick={() => dispatch(openFreshPartFile(partId, 'stepModel', url))} data-tip={t('download_step', { ns: 'naming' })} data-for={tooltipId}>
					<STPFileIcon tooltipMessage={t('download_step', { ns: 'naming' })} />
				</div> :
				<div>

				</div>
			}
			<ReactTooltip
				id={tooltipId}
				place="top"
				type="info"
				effect="solid"
				multiline={false}
			/>
		</div>)
}

StpDownloader.propTypes = {
	partId: PropTypes.number,
	t: PropTypes.func,
}

export default withTranslation()(StpDownloader)
